/**
 * Removes query part from the specified URL
 * @param {String} s URL to parse
 * @returns {String} URL without query part
 */
export function removeQuery (s) {
  if (s != null) {
    const url = s.toString().trim()
    const index = url.indexOf('?')
    return index === -1
      ? url
      : url.substring(0, index)
  }
}

/**
 * Extracts query parameters from a string
 * @param {String} url URL to parse
 * @returns {Object} Dictionary of query parameters, if any are present
 */
export function getQueryParameters (url) {
  if (url) {
    const query = /(?<=\?).*/.exec(url)
    if (query && query[0]) {
      const parameters = query[0]
        .split('&')
        .map(param => param.split('='))
        .filter(([name]) => name.trim())
        .reduce((all, [name, value]) => ({ ...all, [name.trim()]: (value || '').trim() }), {})

      return Object.keys(parameters).length > 0 ? parameters : undefined
    }
  }
}

/**
 * Returns true if specified link is valid
 */
export function isValidUrl (url) {
  // eslint-disable-next-line
  const validator = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
  return url
    ? validator.test(url.toString())
    : false
}

/**
 * Determines whether the specified address or host represents a local host.
 * @param {String} address Internet address or host name
 * @returns {Boolean}
 */
export function isLocalHost (address) {
  return address && (
    address === '127.0.0.1' ||
    address === '::1' ||
    address.includes('localhost')
  )
}

/**
 * Determines whether the specified IP address represents an internal host.
 * @param {String} address Internet address or host name
 * @returns {Boolean}
 */
export function isInternalHost (address) {
  if (address) {
    if (isLocalHost(address)) return true
    const parts = address.split('.').map(p => parseInt(p))
    return (parts[0] === 10 && parts[1] >= 0 && parts[1] <= 255) || // 10.0.0.0 to 10.255.255.255
      (parts[0] === 172 && parts[1] >= 16 && parts[1] <= 31) || // 172.16.0.0 to 172.31.255.255
      (parts[0] === 192 && parts[1] === 168) // 192.168.0.0 to 192.168.255.255
  }
  return false
}
